module.exports = __webpack_public_path__ + "img/01jujia.74ef7c91.png";